export const VIEW_NAMES_ENUM = {
    PRE_RECEIVE: "Pre Receive",
    POST_RECEIVE: "Post Receive",
    DWELL_TIME: "Dwell Time"
};